import store from '../store';
import BASE_PATH from '../constants/path';
import { isAuthenticated } from './authService';
import { getQueryParams } from '../environments/url-helpers';
import {
  FORM_SESSION_TOKEN_PARAM,
  PROJECT_HASH_PARAM,
  REDIRECT_TO_PARAM,
} from '../constants/formParams';
import { getLocalStorageItem, getSessionStorageItem } from './sessionUtils';
import { PROJECT_REGISTRATION_KEY } from '../constants/sessionStorage';
import { getRegistrationUrl } from './functions';

const BASIC_PATHS = {};

export const loginPath = 'login';
export const accountRegisterPath = 'account/create';
export const projectAccountRegisterPath = 'user/register/:projectKey';
export const accountRegisterSuccess = 'account/success';

export const accountEditPath = 'account/edit';
export const myAccountsPath = 'account/my-accounts';
export const forgotPasswordPath = 'account/forgot-password';
export const myRequestsPath = 'my-requests';
export const myFormsPath = 'my-forms';
export const requestDetailsPath = 'request/:requestId/details';

export const PATHS_WITH_PARAMS = {
  welcome: '',
  register: 'register',
  application_sent: 'application-sent',
  error_page: 'error-page',
  login: loginPath,
  my_accounts: myAccountsPath,
  account_register: accountRegisterPath,
  project_account_register: projectAccountRegisterPath,
  forgot_password: forgotPasswordPath,
  account_edit: accountEditPath,
  my_requests: myRequestsPath,
  my_forms: myFormsPath,
  request_details: requestDetailsPath,
  account_register_success: accountRegisterSuccess,
};

const redirectParamsPath = [
  PATHS_WITH_PARAMS.login,
  // PATHS_WITH_PARAMS.account_register,
  // PATHS_WITH_PARAMS.forgot_password,
];

const buildPATHS = (): Dict<string> => {
  const { urlParams } = store.getState().app;
  let PATHS_WITH_DYNAMIC_PARAMS: Dict<string>;

  const PATHS = {
    ...PATHS_WITH_PARAMS,
    account_register: getRegistrationUrl(),
  };

  if (!urlParams) {
    PATHS_WITH_DYNAMIC_PARAMS = Object.entries(PATHS).reduce(
      (acc, [key, path]) => ({ ...acc, [key]: `${BASE_PATH}${path}` }),
      {},
    );
  } else {
    PATHS_WITH_DYNAMIC_PARAMS = Object.entries(PATHS).reduce(
      (acc, [key, path]) => {
        // if(redirectParamsPath.includes(path) && !isRedirectedToParamExists() && !isAuthenticated()) {
        // return { ...acc, [key]: `${BASE_PATH}${path}${urlParams}&redirectTo=${getFormSessionRedirectUrl()}` }
        // } else {
        return { ...acc, [key]: `${BASE_PATH}${path}${urlParams}` };
        // }
      },
      {},
    );
  }

  return {
    ...BASIC_PATHS,
    ...PATHS_WITH_DYNAMIC_PARAMS,
  };
};

export const buildPathsWWithProjectToken = (): Dict<string> => {
  const projectToken = getLocalStorageItem(PROJECT_REGISTRATION_KEY);
  let PATHS_WITH_DYNAMIC_PARAMS: Dict<string>;

  if (!projectToken) {
    PATHS_WITH_DYNAMIC_PARAMS = Object.entries(PATHS_WITH_PARAMS).reduce(
      (acc, [key, path]) => ({ ...acc, [key]: `${BASE_PATH}${path}` }),
      {},
    );
  } else {
    PATHS_WITH_DYNAMIC_PARAMS = Object.entries(PATHS_WITH_PARAMS).reduce(
      (acc, [key, path]) => {
        return {
          ...acc,
          [key]: `${BASE_PATH}${path}?${PROJECT_HASH_PARAM}=${projectToken}`,
        };
      },
      {},
    );
  }

  return {
    ...BASIC_PATHS,
    ...PATHS_WITH_DYNAMIC_PARAMS,
  };
};

export const getRedirectToParam = (): string => {
  const currentUrl = window.location.pathname + window.location.search;
  return encodeURIComponent(currentUrl);
};

export const getFormSessionRedirectUrl = (): string | undefined => {
  const formSessionToken = getQueryParams(window.location.search)[
    FORM_SESSION_TOKEN_PARAM
  ];
  return formSessionToken
    ? `${BASE_PATH}?${FORM_SESSION_TOKEN_PARAM}=${formSessionToken}`
    : undefined;
};

export const getUrlWithProjectToken = (path: string): string | undefined => {
  const projectToken = store.getState().app.accountRegisterUrl;
  if (projectToken) {
    return `${BASE_PATH}${path}?${PROJECT_HASH_PARAM}=${projectToken}`;
  }
  return `${BASE_PATH}${path}`;
};

const isRedirectedToParamExists = (): boolean => {
  const redirectTo = getQueryParams(window.location.search)[REDIRECT_TO_PARAM];
  return redirectTo ? true : false;
};

export const getOnlyFormSessionToken = (): string | undefined => {
  const formSessionToken = getQueryParams(window.location.search)[
    FORM_SESSION_TOKEN_PARAM
  ] as string;

  if (!formSessionToken) return undefined;

  const parts = formSessionToken?.split('-', 2);
  const result = [
    parts[0],
    formSessionToken.substring(formSessionToken.indexOf('-') + 1),
  ];
  return result?.[1] || undefined;
};

export const getPathWithBaseUrl = (path: string): string => {
  return `${BASE_PATH}${path}`;
};

export default buildPATHS;
